<template>
  <div class="schedulingStartPanlThreeContainer">
    <!-- <div class="ml-7 studyClass">
      <span class="font_small">所属学习班：</span>
      <span class="ml-8 font_medium">{{studyclasstitle}}</span>
    </div> -->
    <section class="selectClass">
      <span class="title ml-5 mr-7 font_medium">选中的课程:</span>
      <div class="cont_box">
        <template v-for="(item,index) in courses" >
          <CourseSchedulingCard
            :key="item.id"
            :course="item"
            :timetype="timetype"
            @onClickRemove="onRemoveCourseSuccess(index)"
          ></CourseSchedulingCard>
        </template>
      </div>
    </section>

    <el-divider class="divider">
      <i class="el-icon-thumb"></i>
    </el-divider>

    <div>
      <span class="search_title">可选的课程列表</span>
    </div>
    <section class="search">
      <span class="ml-5">筛选课程:</span>
      <el-input v-model="searchValue" placeholder="可输入进行筛选" class="searchInput ml-10"></el-input>
      <el-button type="success" @click="onClickAddCourseBtn" class="addButton ml-10">
        <span class="el-icon-plus"></span>新建课程
      </el-button>
    </section>

    <section class="studyClassShow ml-5">
      <el-table :data="availableCourses" :empty-text="'没有可以绑定的课程'" style="width: 100%" height="250">
        <el-table-column prop="title" label="课程名"></el-table-column>
        <el-table-column prop="teacher" label="讲师名"></el-table-column>
        <el-table-column fixed="right" width="150" label="操作">
          <template slot-scope="scope">
            <el-button @click="addCourse(scope.row)" type="text" size="small">选择该课程</el-button>
          </template>
        </el-table-column>
      </el-table>
    </section>

    <section class="addCoursePage" v-if="showCourseAdd">
      <schedulingCourseadd 
        @onClickClose="onCloseCoursePanel"
        @onSaveSuccess="onCourseAddCompleted" 
        ref="schedulingCourseadd"></schedulingCourseadd>
    </section>

    <!-- 时间选择器弹窗 -->
    <section class="timeSolt" v-if="isClassTimeShow">
      <div class="box">
        <div class="font_medium theTitle">选择课程开始结束时间</div>
        <div>
          <span class="title">课程开始时间：</span>
          <el-time-select placeholder="起始时间" v-model="starttime" :picker-options="timePickerOption"></el-time-select>
        </div>
        <div>
          <span class="title">课程结束时间：</span>
          <el-time-select placeholder="结束时间" v-model="endtime" :picker-options="timePickerOption"></el-time-select>
        </div>
        <div class="close" @click="hiddenClassTime">
          <i class="el-icon-close"></i>
        </div>
        <el-button type="primary" class="timeOk" @click="onClickConfirmTimeBtn">确定</el-button>
      </div>
    </section>

    <template v-if="isEdit">
      <div class="button_box">
        <el-button type="primary" @click="onUpdate">更新</el-button>
      </div>
    </template>
    <template v-else>
      <div class="button_box">
        <el-button @click="onClickPrevious">上一步</el-button>
        <el-button type="primary" @click="onClickNext">下一步</el-button>
      </div>
    </template>

  </div>
</template>

<script>
import { CourseSchedulingCard } from "@/views/module/start/comp/components/";
import schedulingCourseadd from "@/views/module/start/comp/components/schedulingCourseadd.vue";

import { getOwnCourseApi } from "@/api/module/course/course";
import { schedulingEditInitApi,schedulingEditCourseApi } from "@/api/module/scheduling/scheduling"


export default {
  name: "schedulingCoursePanel",
  components: {
    CourseSchedulingCard,
    schedulingCourseadd
  },
  data() {
    return {
      // edit scope
      id : null,
      loading : false,
      // edit scope end


      courses:[], // [{id,title,starttime,endtime},{}]

      chooseCourse : null,  // 选择的课程

      searchValue : "", //搜索内容
      availableCourses : [],

      showCourseAdd : false,  // 添加课程页面是否显示  false：不显示
      starttime: "",
      endtime : "",

      isClassTimeShow : false,
      timetype : 0



    }
  },
  computed: {
    timePickerOption() {
      if (this.timetype == 0) {
        return {
          start: "06:00",
          step: "00:15",
          end: "12:00",
        };
      } else if (this.timetype == 1) {
        return {
          start: "12:00",
          step: "00:15",
          end: "18:00",
        };
      } else if (this.timetype == 2) {
        return {
          start: "18:00",
          step: "00:15",
          end: "24:00",
        };
      } else {
        return {
          start: "06:00",
          step: "00:15",
          end: "24:00",
        };
      }
    },
    isEdit(){
      return this.id != null;
    }
  },

  methods:{
    init(){
      this.initAvailableCoursesList();

      let id = this.$route.query.id;
      if(id){
        this.id = id;
        schedulingEditInitApi(id)
          .then((r)=>{
            // 初始化选中的
            console.log("schedulingEditInitApi",r)

            this.courses = r.courses;
            this.timetype = r.timetype;

          })
      }
    },

    initAvailableCoursesList(){
      getOwnCourseApi()
        .then((r)=>{
          this.availableCourses = r;
        })
    },

    hiddenClassTime() {
      this.isClassTimeShow = false;
    },

    addCourse(data){
      this.starttime = "";
      this.endtime = "";

      console.log("addCourse",data)

      // 检查是否已添加
      let id = data.id;
      for(let i = 0 ; i < this.courses.length; i++){
        if(this.courses[i].id == id){
          this.$message.error("您已添加过该课程，请勿重复增加");
          return;
        }
      }

      this.chooseCourse = data;

      this.isClassTimeShow = true;
    },

    //   课程开始结束时间  确定按钮
    onClickConfirmTimeBtn() {
        let starttime = this.starttime;
        let endtime = this.endtime;
        if (!starttime || !endtime) {
          this.$message.error("请先添加课程开始、结束时间！");
          return false;
        }

        if(!this.chooseCourse){
          this.$message.error("未选择课程");
          return false;
        }


        let title = this.chooseCourse.title;
        let id = this.chooseCourse.id;

        let course = {
          id : id,
          title : title,
          starttime : starttime,
          endtime : endtime
        }

        this.courses.push(course);
        this.isClassTimeShow = false;
    },


    onClickAddCourseBtn(){
      this.showCourseAdd = true;
    },

    onCourseAddCompleted(data){
      console.log("onCourseAddCompleted")

      this.$message.success("课程已添加，请查看可选课程列表刷新")

      // 关闭卡片，更新选择的数据
      this.showCourseAdd = false;
      this.initAvailableCoursesList();

    },

    onCloseCoursePanel(){
      this.showCourseAdd = false
    },

    onRemoveCourseSuccess(index){
      console.log("onRemoveCourseSuccess",index)

      this.courses.splice(index,1)

    },

    onClickPrevious(){
      this.$emit("onClickPrevious");
    },

    onClickNext(){

      if(!this.courses || this.courses.length == 0){
        this.$message.error("未选中课程");
        return;
      }

      this.$emit("onClickNext",this.courses);
    },

    onUpdate(){
      this.loading = true;
      this.$message.info("更新中")

      schedulingEditCourseApi(this.id,this.courses)
        .then((r)=>{

          this.$message.success("更新成功")
          this.init();
        })
        .finally(()=>{
          this.loading = false;
        })
    },

    onCardConfirm(index,data){
        console.log("onCardConfirm",index,data)
    },

    setTimetype(data){
      this.timetype = data;
    }

  },

  mounted(){
    this.init();
  }
}
</script>



<style lang="scss" scoped>
.center {
  display: flex;
  align-items: center;
  justify-content: center;
}
.title {
  font-size: 14px;
  color: #303133;
  padding-right: 10px;
}
.search {
  //   text-align: center;
  margin-left: 10px;
  span {
    @extend .title;
  }
  .searchInput {
    width: 300px;

    & ::v-deep .el-input__inner {
      border-top-right-radius: 0;
      border-bottom-right-radius: 0;
    }
  }
  .searchButton {
    border-top-left-radius: 0;
    border-bottom-left-radius: 0;
  }
  .addButton {
    .el-icon-plus::before {
      color: #fff;
    }
  }
}
.selectClass {
  margin-left: 10px;
  margin-top: 10px;
  display: flex;
  align-content: center;
  .cont_box {
    display: flex;
    flex-wrap: wrap;
    flex-direction: row;
    justify-content: flex-start;
  }
  .title {
    line-height: 40px;
    display: block;
    white-space: nowrap;
  }
}
.studyClassShow {
  padding: 15px 5px;
}
.addCoursePage {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 10;
  background: rgba($color: #000000, $alpha: 0.8);
  & > div {
    width: 80%;
    position: absolute;
    left: 10%;
    height: 80%;
    top: 8%;
  }
}
.timeSolt {
  width: 100%;
  height: 100%;
  background: rgba($color: #000000, $alpha: 0.8);
  position: fixed;
  top: 0;
  left: 0;
  z-index: 100;
  @extend .center;
  .box {
    @extend .center;
    flex-direction: column;
    padding: 20px 30px;
    background-color: #fff;
    width: 400px;
    height: 200px;
    position: relative;
    .theTitle {
      position: relative;
      top: -10%;
    }
    & > div {
      margin-top: 10px;
    }
    .close {
      position: absolute;
      right: 10px;
      top: -5px;
      font-size: 16px;
      &:hover {
        cursor: pointer;
      }
    }
    .timeOk {
      position: absolute;
      bottom: 10px;
      right: 10px;
    }
  }
}

.schedulingStartPanlThreeContainer {
  width: 60%;

  .divider {
    margin-left: 30px;
    margin-right: 30px;
  }
}
.search_title {
  margin-left: 35px;
  font-size: 14px;
  font-weight: 600;
  border-bottom: 1px solid #ddd;
  width: 100%;
  display: block;
  padding-bottom: 10px;
  margin-bottom: 20px;
}

.button_box{
  padding-left: 20px ;
  padding-bottom: 20px;
  padding-top: 10px;
}

</style>